import { useEffect, useRef } from 'react';
import { Message } from './Message';

const SUGGESTIONS = [
  'Who founded MCG Jazz?',
  'What Grammy-winning recordings are in the archive?',
  'Tell me about jazz history in Pittsburgh',
  'Who are notable artists MCG Jazz has worked with?',
];

export const MessageList = ({ messages, loading, onRegenerate, onSendSuggestion }) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, loading]);

  if (messages.length === 0 && !loading) {
    return (
      <>
        <div className="ChatEmptyState">
          <div className="ChatEmptyState-icon">🎷</div>
          <h2 className="ChatEmptyState-title">MCG Jazz Archive</h2>
          <p className="ChatEmptyState-subtitle">
            Ask me anything about MCG Jazz history, artists, albums, and recordings.
          </p>
          <div className="ChatEmptyState-suggestions">
            {SUGGESTIONS.map((s, i) => (
              <button
                key={i}
                className="ChatSuggestion"
                onClick={() => onSendSuggestion?.(s)}
              >
                {s}
              </button>
            ))}
          </div>
        </div>
        <div ref={messagesEndRef} />
      </>
    );
  }

  // Find last assistant message index for regenerate button placement
  let lastAssistantIndex = -1;
  for (let i = messages.length - 1; i >= 0; i--) {
    if (messages[i].role === 'assistant') {
      lastAssistantIndex = i;
      break;
    }
  }

  return (
    <>
      {messages.map((message, index) => (
        <Message
          key={message.id}
          message={message}
          isLast={index === lastAssistantIndex}
          onRegenerate={index === lastAssistantIndex ? onRegenerate : undefined}
        />
      ))}
      <div ref={messagesEndRef} />
    </>
  );
};
